export default {
    LOAD_INSTRUCTOR_CONCEPT_DATA_SUCCESS: 'LOAD_INSTRUCTOR_CONCEPT_DATA_SUCCESS',
    LOAD_INSTRUCTOR_CONCEPT_DATA_FAILURE: 'LOAD_INSTRUCTOR_CONCEPT_DATA_FAILURE',

    ADD_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: 'ADD_INSTRUCTOR_CONCEPT_ELEM_SUCCESS',
    ADD_INSTRUCTOR_CONCEPT_ELEM_FAILURE: 'ADD_INSTRUCTOR_CONCEPT_ELEM_FAILURE',

    DEL_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: 'DEL_INSTRUCTOR_CONCEPT_ELEM_SUCCESS',
    DEL_INSTRUCTOR_CONCEPT_ELEM_FAILURE: 'DEL_INSTRUCTOR_CONCEPT_ELEM_FAILURE',

    REO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: 'REO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS',
    REO_INSTRUCTOR_CONCEPT_ELEM_FAILURE: 'REO_INSTRUCTOR_CONCEPT_ELEM_FAILURE',

    INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS: 'INFO_INSTRUCTOR_CONCEPT_ELEM_SUCCESS',
    INFO_INSTRUCTOR_CONCEPT_ELEM_FAILURE: 'INFO_INSTRUCTOR_CONCEPT_ELEM_FAILURE',

}